import * as React from "react"

import {DATE_METRICS} from "@constants";
import {SelectSeeker} from "@ui-seeker/core";


const OPTIONS = [
	{label: 'Date', value: DATE_METRICS.DAILY},
	{label: 'Weekly', value: DATE_METRICS.WEEKLY},
	{label: 'Monthly', value: DATE_METRICS.MONTHLY},
	{label: 'Quarterly', value: DATE_METRICS.QUARTERLY},
	{label: 'Yearly', value: DATE_METRICS.YEARLY}
]

export default function BannerPercentageMetricSelect({ value, onChange, excludeOptions=[] }) {
	return <SelectSeeker
		sx={{ minWidth: 150 }}
		options={OPTIONS}
		label="Metric"
		value={value}
		onChange={e => onChange(e.target.value)}
		excludeOptions={excludeOptions}
	/>

}